import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import iconSearch from "../../../assets/Frame 21 (1).png";
import iconLoc from "../../../assets/icon-loc.svg";
import iconWork from "../../../assets/icon-work.svg";
import iconMoney from "../../../assets/HandCoins.png";
import iconFInance from "../../../assets/fi_10349139 (1).png";
import iconSelfie from "../../../assets/Group 1433.png";
import iconHeart from "../../../assets/Vector (30).png";
import iconHabilits from "../../../assets/fi_1242494.png";
import iconFit from "../../../assets/fi_1536828.png";
import iconAwardThin from "../../../assets/icon-award-thin.svg";
import heart from "../../../assets/heartIcon.svg";
import heartInactive from "../../../assets/heartIconInactive.svg";
import iconClose from "../../../assets/icon-close.svg";
import iconProfilePhoto from "../../../assets/user_profile.png";
import iconFoguete from "../../../assets/foguette_elon.svg";

import "./SearchFilter.css";
import SelectInput from "../../../components/inputs/companies/SelectInput/SelectInput";
import { InputAutoComplete } from "../../../components/inputs/companies/InputAutoComplete/InputAutoComplete";
import { Rating, Slider } from "@mui/material";
import ExpandableList from "./ExpandableList";
import axios from "axios";
import hexToRgba from "../../../utils/hexToRgba";
import TextInput from "../../../components/inputs/companies/TextInput/TextInput";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { usePlanPermissions } from "../../../hooks/usePlanPermissions";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TooltipCustom from "../../../components/TooltipCustom";


const SearchFilter = ({
  handleFilterChange,
  filters,
  setFilters,
  fetchTalents,
  brazilStates,
  loading,
  searchTerm,
  currentPage,
  isFilterChange,
  setIsFilterChange,
}) => {
  const [municipios, setMunicipios] = useState([]);
  const [idState, setdState] = useState(null);
  const [placeholderProfile, setPlaceholderProfile] = useState("Todos os perfis");
  const [searchParams, setSearchParams] = useSearchParams();
  const { isValidateAdvancedSearchAccess } = usePlanPermissions();


  // Save filters to URL when they change
  useEffect(() => {
    const params = new URLSearchParams();

    if (filters.location.state) params.set("state", filters.location.state);
    if (filters.location.cities && filters.location.cities.length > 0) params.set("cities", filters.location.cities);
    if (filters.workModel) params.set("workModel", filters.workModel);
    if (filters.contractType) params.set("contractType", filters.contractType);
    if (filters.salary.min) params.set("minSalary", filters.salary.min);
    if (filters.salary.max) params.set("maxSalary", filters.salary.max);
    if (filters.salary.negotiable) params.set("negotiable", filters.salary.negotiable);
    if (filters.selfieLetter) params.set("selfieLetter", filters.selfieLetter);
    if (filters.hasProfilePhoto) params.set("hasProfilePhoto", filters.hasProfilePhoto);
    if (filters.primary) params.set("primary", filters.primary);
    if (filters.secondary) params.set("secondary", filters.secondary);
    if (filters.balanced) params.set("balanced", filters.balanced);
    if (filters.seniorityLevel) params.set("seniorityLevel", filters.seniorityLevel);
    if (filters.searchTerm) params.set("searchTerm", filters.searchTerm);

    // Preserve page only if it's NOT a filter change (i.e., it's a refresh)
    const currentPageFromUrl = parseInt(searchParams.get("page")) || 1;
    if (currentPageFromUrl > 1 && !isFilterChange && searchParams.has("page")) {
      params.set("page", currentPageFromUrl);
    }

    const knowledge = filters.knowledge
      .filter((k) => k.checked)
      .map(({ id, level }) => ({ id, level }));

    const skills = [];
    filters.skills.forEach((category) => {
      const key = Object.keys(category)[0];
      category[key].forEach((item) => {
        if (item.checked) {
          skills.push({ id: item.id, level: item.level });
        }
      });
    });

    if (knowledge.length > 0) {
      params.set("knowledge", JSON.stringify(knowledge));
    }
    if (skills.length > 0) {
      params.set("skills", JSON.stringify(skills));
    }

    setSearchParams(params);
  }, [filters, searchTerm, isFilterChange, setIsFilterChange]); // Adicionado isFilterChange e setIsFilterChange

  const getMUnicipios = async (id) => {
    setMunicipios([]);
    try {
      const data = await axios.get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${id}/municipios`
      );
      if (data) {
        setMunicipios(data?.data);
        sessionStorage.setItem("idState", id);
      }
    } catch (error) {}
  };

  useEffect(() => {
    const stateId = filters.location.state;
    if (stateId && stateId !== idState) {
      setdState(stateId);
      getMUnicipios(stateId);
    }
  }, [filters.location.state]);

  const handleTooltip = (value) => {
    const knowledgeAreas = {
      0: "Quero aprender",
      1: "Sei o básico",
      2: "Me viro bem",
      3: "Posso ensinar",
    };

    return knowledgeAreas[value] || null;
  };

  const handleRatingChange = async (event, newValue, id) => {
    const updatedKnowledge = filters.knowledge.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          level: newValue,
          checked: newValue > 0,
        };
      }
      return item;
    });

    handleFilterChange("knowledge", updatedKnowledge);
  };

  const handleSkillLevelChange = (id, level) => {
    const updatedSkills = filters.skills.map((category) => {
      const key = Object.keys(category)[0];
      const updatedItems = category[key].map((item) =>
        item.id === id ? { ...item, level, checked: level > 0 } : item
      );
      return { [key]: updatedItems };
    });

    handleFilterChange("skills", updatedSkills);
  };


  const MessageButton = ({ text }) => {
    return (
      <button
        className="message-button"
        style={{ opacities: text !== null ? 1 : 0 }}
      >
        {text}
      </button>
    );
  };

  const filterCheckedSkills = (skills) => {
    const result = [];

    // Iterate over each skill category
    for (const category of skills) {
      // For each category, get the category name (first key)
      const categoryName = Object.keys(category)[0];

      // Filter only checked items within this category
      const checkedItems = category[categoryName].filter(
        (item) => item.checked === true
      );

      // Map id, name and level of checked items and add to result
      checkedItems.forEach((item) => {
        result.push({
          id: item.id,
          name: item.name,
          level: item.level,
        });
      });
    }

    return result || null;
  };

  const filterCheckedKnoledge = (skills) =>
    skills
      ?.filter((item) => item.checked)
      .map(({ name, level }) => ({ name, level })) || null;

  const cardsKnoledge = filterCheckedKnoledge(filters.knowledge);

  const cardsSkils = filterCheckedSkills(filters.skills);

  const sliderHandleColor = (value) => {
    switch (value) {
      case 0:
        return "black";
      case 1:
        return "#EC5569";
      case 2:
        return "#ECA355";
      case 3:
        return "#009ABC";
      case 4:
        return "#57BAB8";
      default:
        return null;
    }
  };

  const handleValueLabelFormat = (value) => {
    switch (value) {
      case 0:
        return "Não conheço";
      case 1:
        return "Sei o básico";
      case 2:
        return "Estou aprendendo";
      case 3:
        return "Me viro bem";
      case 4:
        return "Sou expert";
      default:
        return null;
    }
  };

  const labelProfile = {
    i: "Idealizador",
    c: "Comunicador",
    a: "Analítico",
    e: "Executor",
  };

  const labelWorkModel = {
    "in_person": "Presencial",
    "remote": "Home Office",
    "hybrid": "Híbrido"
  }

  const labelContractType = {
    "clt": "CLT",
    "pj": "PJ"
  }

  const labelSeniority = {
    "assistant": "Auxiliar",
    "associate": "Assistente",
    "junior_analyst": "Analista Jr.",
    "analyst": "Analista Pleno",
    "senior_analyst": "Analista Sênior",
    "coordinator": "Coordenador",
    "manager": "Gerente",
    "director": "Diretor",
    "c_level": "C-Level"
  }

  const [visibleCount, setVisibleCount] = useState(3); // Start showing 3 items
  const [showAll, setShowAll] = useState(false);

  const visibleItems = showAll
    ? filters?.knowledge
    : filters?.knowledge?.slice(0, visibleCount);

  const handleShowMore = () => {
    setVisibleCount(visibleCount + 3); // Add 3 more items on each click
    if (visibleCount >= filters?.knowledge?.length) {
      setShowAll(true); // If all items are visible, switch to "Show Less" mode
    }
  };

  const handleShowLess = () => {
    setVisibleCount(3); // Go back to showing only the first 3
    setShowAll(false);
  };

  // Remove handler functions
  const handleRemoveFilter = (filterType, value) => {
    switch (filterType) {
      case "location_state":
        handleFilterChange("location", { state: "", cities: "" });
        break;
      case "location_cities":
        handleFilterChange("location", { ...filters.location, cities: "" });
        break;
      case "workModel":
        handleFilterChange("workModel", "");
        break;
      case "contractType":
        handleFilterChange("contractType", "");
        break;
      case "seniorityLevel":
        handleFilterChange("seniorityLevel", "");
        break;
      case "salary_min":
        handleFilterChange("salary", { ...filters.salary, min: "" });
        break;
      case "salary_max":
        handleFilterChange("salary", { ...filters.salary, max: "" });
        break;
      case "salary_negotiable":
        handleFilterChange("salary", { ...filters.salary, negotiable: false });
        break;
      case "selfieLetter":
        handleFilterChange("selfieLetter", false);
        break;
      case "hasProfilePhoto":
        handleFilterChange("hasProfilePhoto", false);
        break;
      case "knowledge":
        const updatedKnowledge = filters.knowledge.map((item) =>
          item.name === value ? { ...item, checked: false, level: 0 } : item
        );
        handleFilterChange("knowledge", updatedKnowledge);
        break;
      case "skills":
        // Updating skills is more complex because of the nested structure
        const updatedSkills = [...filters.skills];
        for (let i = 0; i < updatedSkills.length; i++) {
          const categoryName = Object.keys(updatedSkills[i])[0];
          const items = updatedSkills[i][categoryName];

          for (let j = 0; j < items.length; j++) {
            if (items[j].name === value) {
              items[j].checked = false;
              items[j].level = 0; // Reset level to 0
              break;
            }
          }
        }
        handleFilterChange("skills", updatedSkills);
        break;
      case "primary":
        handleFilterChange("primary", "");
        break;
      case "secondary":
        handleFilterChange("secondary", "");
        break;
      case "balanced":
        handleFilterChange("balanced", false);
        break;
      default:
        break;
    }
  };

  // Debounce refs for salary inputs
  const salaryMinDebounce = useRef(null);
  const salaryMaxDebounce = useRef(null);

  return (
    <div className="sidebarFilter">
      {/* <div className="search-container">
        <input
          type="text"
          placeholder="Pesquisar filtro"
          className="search-input"
        />
        <img src={iconSearch} alt="" />
      </div> */}

      {/* <div className="selected-filters">
        <span className="filter-tag">
          Gestão de Pessoas
          <span className="material-icons">favorite</span>
          <button>&times;</button>
        </span>
      </div> */}

      {(
        filters.location.state ||
        (filters.location.cities && filters.location.cities.length > 0)  ||
        filters.workModel ||
        filters.contractType ||
        filters.salary.min ||
        filters.salary.max ||
        filters.salary.negotiable ||
        filters.seniorityLevel ||
        filters.hasProfilePhoto ||
        filters.selfieLetter ||
        filters.knowledge.some((k) => k.checked) ||
        filters.skills.some((cat) => {
          const key = Object.keys(cat)[0];
          return cat[key].some((s) => s.checked);
        }) ||
        filters.primary ||
        filters.secondary ||
        filters.balanced
      ) && (
        <>
          <div className="title">Filtros selecionados</div>
          <div className="containerFIltersSelecteds">
            {filters?.location?.state && (
              <div className="cardFilterSelected">
                <img src={iconLoc} alt="" />
                <div className="text">
                  {(() => {
                    const state = brazilStates?.find(
                      (item) => Number(item.id) === Number(filters?.location?.state)
                    );
                    return state?.sigla;
                  })()}
                </div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("location_state")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {Array.isArray(filters?.location?.cities) &&
              filters.location.cities.map((cities) => (
                <div key={cities} className="cardFilterSelected">
                  <img src={iconLoc} alt="" />
                  <div className="text">{cities}</div>
                  <button
                    className="remove-filter-btn"
                    onClick={() =>
                      handleFilterChange("location", {
                        ...filters.location,
                        cities: filters.location.cities.filter((c) => c !== cities),
                      })
                    }
                  >
                    <img src={iconClose} alt="remover" />
                  </button>
                </div>
              ))}

            {filters?.workModel && (
              <div className="cardFilterSelected">
                <img src={iconWork} alt="" />
                <div className="text">{labelWorkModel[filters?.workModel]}</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("workModel")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {filters?.contractType && (
              <div className="cardFilterSelected">
                <img src={iconWork} alt="" />
                <div className="text">{labelContractType[filters?.contractType]}</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("contractType")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {filters?.seniorityLevel && (
              <div className="cardFilterSelected">
                <img src={iconAwardThin} alt="" />
                <div className="text">{labelSeniority[filters?.seniorityLevel]}</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("seniorityLevel")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {filters?.salary?.min && (
              <div className="cardFilterSelected">
                <img src={iconMoney} alt="" />
                <div className="text">{`a partir de R$ ${filters?.salary?.min}`}</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("salary_min")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {filters?.salary?.max && (
              <div className="cardFilterSelected">
                <img src={iconMoney} alt="" />
                <div className="text">{`até R$ ${filters?.salary?.max}`}</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("salary_max")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {filters?.salary?.negotiable && (
              <div className="cardFilterSelected">
                <img src={iconMoney} alt="" />
                <div className="text">Aberto a negociações</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("salary_negotiable")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {filters?.selfieLetter && (
              <div className="cardFilterSelected">
                <img src={iconSelfie} alt="" />
                <div className="text">Selfie obrigatória</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("selfieLetter")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {filters?.hasProfilePhoto && (
              <div className="cardFilterSelected">
                <img src={iconProfilePhoto} alt="" />
                <div className="text">Foto obrigatória</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("hasProfilePhoto")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {cardsKnoledge &&
              cardsKnoledge.map((item) => (
                <div key={item.name} className="cardFilterSelected">
                  <div className="text">{item?.name}</div>
                  <Rating
                    value={item.level}
                    onChange={(e, newValue) =>
                      handleRatingChange(e, newValue, item.id)
                    }
                    precision={1}
                    max={3}
                    icon={<img src={heart} alt="heart" style={{ width: "12px" }} />}
                    emptyIcon={
                      <img
                        src={heartInactive}
                        alt="heart"
                        style={{ width: "12px" }}
                      />
                    }
                    sx={{
                      "& .MuiRating-icon": {
                        margin: "1px", // Space between icons
                      },
                    }}
                  />

                  <button
                    className="remove-filter-btn"
                    onClick={() => handleRemoveFilter("knowledge", item.name)}
                  >
                    <img src={iconClose} alt="remover" />
                  </button>
                </div>
              ))}

            {cardsSkils &&
              cardsSkils.map((item, idx) => (
                <div key={`${item.name}-${idx}`} className="cardFilterSelected">
                  <div className="text">{item?.name}</div>
                  {item.level > 0 && (
                    <Slider
                      style={{
                        margin: "0px",
                        width: "30px",
                        padding: "0px",
                      }}
                      sx={{
                        "& .MuiSlider-thumb:hover": {
                          boxShadow: `0px 0px 0px 8px ${hexToRgba(
                            sliderHandleColor(item.level),
                            0.16
                          )}`,
                        },
                        "& .MuiSlider-thumb.Mui-active": {
                          boxShadow: `0px 0px 0px 14px ${hexToRgba(
                            sliderHandleColor(item.level),
                            0.16
                          )}`,
                        },
                        "& .MuiSlider-thumb": {
                          width: 0, // Adjust thumb size
                          height: 0, // Adjust thumb size
                          marginLeft: "-8px",
                        },
                        "& .MuiSlider-track": {
                          height: 6, // Ensure track height matches your design
                        },
                      }}
                      slotProps={{
                        track: {
                          style: {
                            backgroundColor: sliderHandleColor(item.level),
                            // borderColor: sliderHandleColor(item.level),
                            border: "0.95px solid #ABABAB",
                            height: "6px",
                          },
                        },
                        thumb: {
                          style: {
                            backgroundColor: "#575757",
                            marginLeft:
                              item.level === 0 || item.level === undefined
                                ? "8px"
                                : null,
                            border: "0px solid #ffff",
                            ":hover": {
                              color: sliderHandleColor(item.level),
                            },
                          },
                        },
                        rail: {
                          style: {
                            backgroundColor: "#FFFFFF",
                            height: "6px",
                            border: "0.95px solid #ABABAB",
                            width: "100%",
                          },
                        },
                      }}
                      min={0}
                      defaultValue={0}
                      value={item.level}
                      max={4}
                      valueLabelFormat={handleValueLabelFormat}
                      valueLabelDisplay="auto"
                    />
                  )}

                  <button
                    className="remove-filter-btn"
                    onClick={() => handleRemoveFilter("skills", item.name)}
                  >
                    <img src={iconClose} alt="remover" />
                  </button>
                </div>
              ))}

            {filters?.primary && (
              <div className="cardFilterSelected">
                {/* <img src={iconMoney} alt="" /> */}
                <div className="text">{labelProfile[filters?.primary]}</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("primary")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {filters?.secondary && (
              <div className="cardFilterSelected">
                {/* <img src={iconMoney} alt="" /> */}
                <div className="text">{labelProfile[filters?.secondary]}</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("secondary")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            {filters?.balanced && (
              <div className="cardFilterSelected">
                {/* <img src={iconMoney} alt="" /> */}
                <div className="text">Perfil equilibrado</div>
                <button
                  className="remove-filter-btn"
                  onClick={() => handleRemoveFilter("balanced")}
                >
                  <img src={iconClose} alt="remover" />
                </button>
              </div>
            )}

            <div className="dividerFilters">
              <div className="divider" />
            </div>

          </div>
        </>
      )}

      <div className="title">
        <img src={iconLoc} alt="" />
        Localização
      </div>

      <div className="filter-section">
        <div className="input">
          <SelectInput
            name="state"
            label="Estado"
            placeholder="Todos os estados"
            disabled={brazilStates?.length <= 0}
            value={String(filters.location.state)}
            onChange={(val) => {
              getMUnicipios(val);
              handleFilterChange("location", {
                ...filters.location,
                state: val,
              });
            }}
            options={brazilStates
              ?.sort((a, b) => a.nome.localeCompare(b.nome))
              ?.map((item) => ({ label: item.nome, value: String(item.id) }))}
          />
        </div>

        <div className="input">
          <InputAutoComplete
            name="cities"
            label="Cidade"
            placeholder="Todas as cidades"
            multiple
            options={municipios?.map((item) => ({
              label: item.nome,
              value: item.nome,
            }))}
            value={
              Array.isArray(filters.location.cities)
                ? filters.location.cities.map((c) => ({ label: c, value: c }))
                : []
            }
            onChange={(_, selected) => {
              handleFilterChange("location", {
                ...filters.location,
                cities: selected.map((item) => item.value),
              });
            }}
          />
        </div>
      </div>

      <div className="title">
        <img src={iconWork} alt="" />
        Contrato
      </div>

      <div className="filter-section">
        <div className="input">
          <SelectInput
            name="contractType"
            label="Regime de Contratação"
            placeholder="Todos os Regimes"
            value={filters.contractType}
            onChange={(val) => handleFilterChange("contractType", val)}
            options={Object.entries(labelContractType).map(([value, label]) => ({
              value,
              label
            }))}
          />
        </div>

        <div className="input">
          <SelectInput
            name="workModel"
            label="Modelo de Trabalho"
            placeholder="Todos os Modelos"
            value={filters.workModel}
            onChange={(val) => handleFilterChange("workModel", val)}
            options={Object.entries(labelWorkModel).map(([value, label]) => ({
              value,
              label
            }))}
          />
        </div>
      </div>

      <div className="title">
        <img src={iconAwardThin} alt="" />
        Senioridade
      </div>

      <div className="filter-section">
        <div className="input">
          <SelectInput
            name="seniorityLevel"
            label="Nível de Senioridade"
            placeholder="Todas as senioridades"
            value={filters.seniorityLevel}
            onChange={(val) => handleFilterChange("seniorityLevel", val)}
            options={Object.entries(labelSeniority).map(([value, label]) => ({
              value,
              label
            }))}
          />
        </div>
      </div>

      <div className="title">
        <img src={iconFInance} alt="" />
        Pretensão Salarial
        {!isValidateAdvancedSearchAccess()?.allowed && (
          <TooltipCustom disabled={true}>
            <img src={iconFoguete} alt="" />
          </TooltipCustom>
        )}
      </div>

      <div className="filter-section" style={{ opacity: !isValidateAdvancedSearchAccess()?.allowed ? 0.3 : 1, pointerEvents: !isValidateAdvancedSearchAccess()?.allowed ? 'none' : 'auto' }}>
        <div className="inputsContainer">
          <div className="salary-inputs">
            <TextInput
              name="salary_min"
              label="Mínimo"
              maskType="currency"
              value={filters.salary.min || ""}
              onChange={(value) => {
                handleFilterChange("salary", {
                  ...filters.salary,
                  min: value,
                });

                clearTimeout(salaryMaxDebounce.current);
                salaryMaxDebounce.current = setTimeout(() => {
                  const maxValue = filters.salary.max;
                  if (maxValue && Number(maxValue) < Number(value)) {
                    handleFilterChange("salary", {
                      ...filters.salary,
                      max: "",
                      min: value,
                    });
                  }
                }, 500);
              }}
              placeholder="Mínimo"
              disabled={!isValidateAdvancedSearchAccess()?.allowed}
            />
          </div>
          <div className="salary-inputs">
            <TextInput
              name="salary_max"
              label="Máximo"
              maskType="currency"
              value={filters.salary.max || ""}
              onChange={(value) => {
                handleFilterChange("salary", {
                  ...filters.salary,
                  max: value,
                });

                clearTimeout(salaryMinDebounce.current);
                salaryMinDebounce.current = setTimeout(() => {
                  const minValue = filters.salary.min;
                  if (minValue && Number(value) < Number(minValue)) {
                    handleFilterChange("salary", {
                      ...filters.salary,
                      min: "",
                      max: value
                    });
                  }
                }, 500);
              }}
              placeholder="Máximo"
              disabled={!isValidateAdvancedSearchAccess()?.allowed}
            />
          </div>
        </div>
        <label className="check-label">
          <input
            type="checkbox"
            name="salary"
            value={filters.salary.negotiable ?? false}
            checked={filters.salary.negotiable ?? false}
            onChange={(e) =>
              handleFilterChange("salary", {
                ...filters.salary,
                negotiable: !filters.salary.negotiable,
              })
            }
            disabled={!isValidateAdvancedSearchAccess()?.allowed}
          />
          Aberto a negociações
        </label>
      </div>

      <div className="title" style={{ marginTop: 15 }}>
        <img src={iconSelfie} alt="" />
        Selfie Letter
        {!isValidateAdvancedSearchAccess()?.allowed && (
          <TooltipCustom disabled={true}>
            <img src={iconFoguete} alt="" />
          </TooltipCustom>
        )}
      </div>

      <div className="filter-section" style={{ opacity: !isValidateAdvancedSearchAccess()?.allowed ? 0.3 : 1, pointerEvents: !isValidateAdvancedSearchAccess()?.allowed ? 'none' : 'auto' }}>
        <div className="radio-group">
          <label className="radio-label">
            <input
              type="radio"
              name="selfie"
              value="optional"
              checked={!filters.selfieLetter}
              onChange={(e) => handleFilterChange("selfieLetter", false)}
              disabled={!isValidateAdvancedSearchAccess()?.allowed}
            />
            Opcional
          </label>
          <label className="radio-label">
            <input
              type="radio"
              name="selfie"
              value="required"
              checked={filters.selfieLetter}
              onChange={() => handleFilterChange("selfieLetter", true)}
              disabled={!isValidateAdvancedSearchAccess()?.allowed}
            />
            Obrigatória
          </label>
        </div>
      </div>

      <div className="title" style={{ marginTop: 15 }}>
        <img src={iconProfilePhoto} alt="" />
        Foto no perfil
      </div>

      <div className="filter-section">
        <div className="radio-group">
          <label className="radio-label">
            <input
              type="radio"
              name="profilePhoto"
              value="optional"
              checked={!filters.hasProfilePhoto}
              onChange={() => handleFilterChange("hasProfilePhoto", false)}
            />
            Opcional
          </label>
          <label className="radio-label">
            <input
              type="radio"
              name="profilePhoto"
              value="required"
              checked={filters.hasProfilePhoto}
              onChange={() => handleFilterChange("hasProfilePhoto", true)}
            />
            Obrigatória
          </label>
        </div>
      </div>

      {/* Knowledge section as Accordion */}
      <Accordion
        className="knowledge-accordion"
        disableGutters
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className="knowledge-accordion-summary"
        >
          <div className="title">
            <img src={iconHeart} alt="" className="knowledge-icon" />
            <span className="knowledge-title">Conhecimentos</span>
          </div>
        </AccordionSummary>
        <AccordionDetails className="knowledge-accordion-details">
          <div className="filter-section">
            {filters?.knowledge
              ?.slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((item) => (
                <div key={item.id} className={`card ${item.checked && "checked"}`}>
                  <label className="check-label">
                    <input
                      type="checkbox"
                      name="knowledge"
                      value={item.checked}
                      checked={item.checked}
                      onChange={() => {
                        // Update state when an item is checked
                        const updatedKnowledge = filters.knowledge.map((k) =>
                          k.id === item.id ? { ...k, checked: !k.checked } : k
                        );
                        handleFilterChange("knowledge", updatedKnowledge);
                      }}
                    />
                  </label>
                  <div className="conteinerNivel">
                    <div className="text">{item.name}</div>
                    <div className="knowledge-rating-container">
                      <Rating
                        value={item.level ?? 0}
                        precision={1}
                        max={3}
                        icon={<img src={heart} alt="heart" />}
                        emptyIcon={<img src={heartInactive} alt="heart" />}
                        onChange={(e, newValue) =>
                          handleRatingChange(e, newValue, item.id)
                        }
                        className="knowledge-rating"
                      />
                      {item.level && item.level > 0 ? (
                        <MessageButton text={handleTooltip(item?.level)} />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </AccordionDetails>
      </Accordion>

      <div className="filter-section" style={{ gap: 0 }}>
        <div className="title">
          <img src={iconHabilits} alt="" />
          Habilidades
          {!isValidateAdvancedSearchAccess()?.allowed && (
            <>
              <TooltipCustom disabled={true} 
                firstText="Para ter acesso a filtros avançados de cada habilidade, atualize seu plano." 
                secondText="Recurso disponível nos planos Galaxy e Infinity">
                <img src={iconFoguete} alt="" />
              </TooltipCustom>
            </>
          )}
        </div>
        <ExpandableList
          filters={filters}
          handleFilterChange={handleFilterChange}
          handleSkillLevelChange={handleSkillLevelChange}
          isValidateAdvancedSearchAccess={isValidateAdvancedSearchAccess}
        />
      </div>

      <div className="title">
        <img src={iconFit} alt="" />
        Fit Cultural
        {!isValidateAdvancedSearchAccess()?.allowed && (
          <TooltipCustom disabled={true}>
            <img src={iconFoguete} alt="" />
          </TooltipCustom>
        )}
      </div>

      <div className="filter-section" style={{ opacity: !isValidateAdvancedSearchAccess()?.allowed ? 0.4 : 1 }}>
        <div className="input">
          <SelectInput
            name="primary"
            label="Perfil dominante"
            placeholder={placeholderProfile}
            disabled={filters.balanced || !isValidateAdvancedSearchAccess()?.allowed}
            value={filters.primary}
            onChange={(val) => handleFilterChange("primary", val)}
            options={["i", "c", "a", "e"]
              .filter((value) => value !== filters.secondary)
              .map((value) => ({ label: labelProfile[value], value }))}
           />
        </div>

        <div className="input">
          <SelectInput
            name="secondary"
            label="Perfil secundário"
            placeholder={placeholderProfile}
            disabled={filters.balanced || !isValidateAdvancedSearchAccess()?.allowed}
            value={filters.secondary}
            onChange={(val) => handleFilterChange("secondary", val)}
            options={["i", "c", "a", "e"]
              .filter((value) => value !== filters.primary)
              .map((value) => ({ label: labelProfile[value], value }))}
          />
        </div>

        <label className="check-label">
          <input
            type="checkbox"
            name="balanced"
            value={filters.balanced ?? false}
            checked={filters.balanced ?? false}
            disabled={!isValidateAdvancedSearchAccess()?.allowed}
            onChange={() => {
              const newBalanced = !(filters.balanced ?? false);
              handleFilterChange("balanced", newBalanced);

              if (newBalanced) {
                setPlaceholderProfile("Perfil equilibrado");
                handleFilterChange("primary", "");
                handleFilterChange("secondary", "");
              } else {
                setPlaceholderProfile("Todos os perfis");
              }
            }}
          />
          Perfil equilibrado
        </label>
      </div>

      {/* <button className="search-button" onClick={fetchTalents}>
        {loading ? "Carregando..." : "Buscar talentos"}
      </button> */}
    </div>
  );
};

export default SearchFilter;
